import ResourceApi from '../ResourceApi';

const LegacyUserResource = {
  index: async (params = {}) => (await ResourceApi.get('/resource/users-legacy', params)).data,
  get: async (id) => (await ResourceApi.get(`/resource/users-legacy/${id}`)).data,
  update: async (userId, user) => (await ResourceApi.put(`/resource/users-legacy/${userId}`, user)).data,
  //   TODO update below routes
  putHealthInfo: async (id, params) => (await ResourceApi.put(`/resource/users-legacy/${id}/health-info`, params)).data,
  bradfordFactor: async (id) => (await ResourceApi.get(`/resource/users-legacy/${id}/bradford-factor`)).data,
  lateness: async (id, start, end) => (await ResourceApi.get(`/resource/users-legacy/${id}/lateness`, { start, end })).data,
  estimation: async (id, start, end) => (await ResourceApi.get(`/resource/users-legacy/${id}/estimation`, { start, end })).data,
  timeSpent: async (id, start, end) => (await ResourceApi.get(`/resource/users-legacy/${id}/time-spent`, { start, end })).data,
  workingHours: async (id, start, end) => (await ResourceApi.get(`/resource/users-legacy/${id}/working-hours`, { start, end })).data,
  reviewRating: async (id, reviewer, type, start, end) => (await ResourceApi.get(`/resource/users-legacy/${id}/review-rating`, {
    reviewer,
    type,
    start,
    end,
  })).data,
};

export default LegacyUserResource;
